import * as React from "react";
import { Calendar } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/** Native `type="date"` with Lucide calendar icon (theme-aware); native glyph hidden but still opens picker. */
const DateInput = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<typeof Input>, "type">
>(({ className, ...props }, ref) => (
  <div className="relative w-full">
    <Input
      ref={ref}
      type="date"
      className={cn(
        "relative pr-10",
        // Keep native hit target on the right; draw our own icon behind it
        "[&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-2.5 [&::-webkit-calendar-picker-indicator]:top-1/2 [&::-webkit-calendar-picker-indicator]:z-20 [&::-webkit-calendar-picker-indicator]:-translate-y-1/2 [&::-webkit-calendar-picker-indicator]:h-4 [&::-webkit-calendar-picker-indicator]:w-4 [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-0",
        "[&::-moz-calendar-picker-indicator]:absolute [&::-moz-calendar-picker-indicator]:right-2.5 [&::-moz-calendar-picker-indicator]:top-1/2 [&::-moz-calendar-picker-indicator]:z-20 [&::-moz-calendar-picker-indicator]:-translate-y-1/2 [&::-moz-calendar-picker-indicator]:h-4 [&::-moz-calendar-picker-indicator]:w-4 [&::-moz-calendar-picker-indicator]:cursor-pointer [&::-moz-calendar-picker-indicator]:opacity-0",
        className
      )}
      {...props}
    />
    <Calendar
      className="pointer-events-none absolute right-3 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-muted-foreground"
      strokeWidth={2}
      aria-hidden
    />
  </div>
));
DateInput.displayName = "DateInput";

export { DateInput };
